
let baseUrl = '';
let webUrl = '';
let appUrl = ''; // 应用详情地址
let resoureUrl = ''; // 资源详情地址
let teacherUrl = ''; // 教师详情地址
const protocol = window.location.protocol;
if (process.env.NODE_ENV === 'development') { // 本地前端
  // baseUrl = `http://192.168.68.140:7767`; // 邓梦佳
  baseUrl = protocol + '//gw.kqedu.net/portal/';
  appUrl = protocol + '//app.kqedu.net';
  teacherUrl = protocol + '//t.kqedu.net';
  resoureUrl = protocol + '//strs.kqedu.net';
  webUrl = protocol + '//www.kqedu.net/#';
} else {
  if (process.env.VUE_APP_TITLE === 'test') { // 测试环境
    baseUrl = `https://cgw-test.cunwedu.com.cn/portal/`;
    webUrl = 'https://gate-test.cunwedu.com.cn/#';
    appUrl = 'https://www-nm.cunwedu.com.cn/';
    teacherUrl = 'https://t-test.cunwedu.com.cn';
    resoureUrl = 'http://strs-test.cunwedu.com.cn';
  } else if (process.env.VUE_APP_TITLE === 'dev') { // 开发环境
    baseUrl = `https://cgw-dev.cunwedu.com.cn/portal/`;
    appUrl = 'https://www-dev.cunwedu.com.cn';
    teacherUrl = 'https://t-dev.cunwedu.com.cn';
    resoureUrl = 'http://strs-dev.cunwedu.com.cn';
    webUrl = 'https://gate-dev.cunwedu.com.cn/#';
  } else if (process.env.VUE_APP_TITLE === 'pre') { // 预发布环境
    baseUrl = `https://cgw-pre.cunwedu.com.cn/portal/`;
    appUrl = 'https://www-nm.cunwedu.com.cn/';
    teacherUrl = 'https://t-nm.cunwedu.com.cn';
    resoureUrl = 'https://strs-nm.cunwedu.com.cn';
    webUrl = 'https://gate-nm.cunwedu.com.cn/#';
  } else { // 生产环境
    baseUrl = protocol + '//gw.kqedu.net/portal/';
    appUrl = protocol + '//app.kqedu.net';
    teacherUrl = protocol + '//t.kqedu.net';
    resoureUrl = protocol + '//strs.kqedu.net';
    webUrl = protocol + '//www.kqedu.net/#';
  }
}
const ENVIRONMENT = {
  BASE_API: baseUrl, // api访问地址
  BASE_URL: webUrl,
  appUrl,
  teacherUrl,
  resoureUrl
};

export default ENVIRONMENT;
